import DatePicker, {
    DateObject,
    DatePickerProps,
} from 'react-multi-date-picker'

import persian from 'react-date-object/calendars/persian'
import persian_fa from 'react-date-object/locales/persian_fa'
import './datePicker.styles.scss'
import 'react-multi-date-picker/styles/layouts/mobile.css'
import moment from 'jalali-moment'
import classNames from 'classnames'
import 'react-multi-date-picker/styles/colors/green.css'
interface ICustomDatePickerProps extends DatePickerProps {
    value?: Date | string
    title: string
    name: string
    minDate?: string | Date | undefined
    setValue: (e: string) => void
    placeHolder: string
    isEdit?: boolean
}

const CustomDatePicker = ({
    value,
    title,
    name,
    minDate,
    setValue,
    placeHolder,
    isEdit,
}: ICustomDatePickerProps) => {
    const handleSelect = (selectedDates: DateObject) => {
        if (selectedDates)
            setValue(
                moment(new Date(selectedDates?.toDate?.())).format('YYYY-MM-DD')
            )
    }
    return (
        <>
            <div
                className={classNames(
                    isEdit
                        ? 'custom-floating-label-input-isEdit '
                        : 'custom-floating-label-input '
                )}
            >
                <DatePicker
                    minDate={minDate}
                    format="YYYY/MM/DD"
                    calendar={persian}
                    locale={persian_fa}
                    value={value}
                    onChange={handleSelect}
                    inputClass={''}
                    calendarPosition="bottom-center"
                    containerStyle={{
                        width: '100%',
                    }}
                    name={name}
                    id={name}
                    placeholder={placeHolder}
                    className="green"
                />
            </div>
        </>
    )
}

export default CustomDatePicker
